/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { JSX } from "react"

import { forceHomeRedirect } from "../../utils/force-redirect"
import "./page-not-found-view.css"

export const PageNotFoundView = (): JSX.Element => {
    return (
        <div className="page-not-found-view flex justify-center h-screen">
            <div className="centered shadow-legacy-sm rounded-legacy-lg p-12">
                <div className="logo mb-6">
                    <span className="me-2 mb-2">
                        <img src="/assets/iap-logo.svg" alt="In-App Protection logo" width={30} />
                    </span>
                    <h3 className={"font-bold"}>In-App Protection</h3>
                </div>

                <h3>Page Not Found</h3>

                <div className="mt-legacy mb-legacy">
                    <p>Sorry, the page you&apos;re looking for doesn&apos;t exist.</p>
                    <button className="btn btn-primary mt-6" onClick={() => forceHomeRedirect()}>
                        Go to Dashboard
                    </button>
                </div>
            </div>
        </div>
    )
}
